import React, { FC } from 'react';

interface IVideoProps {
  src: string;
  width?: number;
  height?: number;
  controls?: boolean;
  autoPlay?: boolean;
  loop?: boolean;
  muted?: boolean;
  poster?: string;
  onCanPlay?: () => void;
}

const Video: FC<IVideoProps> = ({
  src,
  width = 1280,
  height = 720,
  controls = true,
  autoPlay = false,
  loop = false,
  muted = false,
  poster,
  onCanPlay,
}) => {
  return (
    <>
      <video
        src={src}
        width={width}
        height={height}
        controls={controls}
        autoPlay={autoPlay}
        loop={loop}
        poster={poster}
        muted={muted}
        onCanPlay={onCanPlay}
      />
    </>
  );
};

export default Video;
